var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createEffect, createEvent, createStore, guard, sample, } from "effector";
import { $playerCurrentTrackSource, $playerTrackQueue, setPlayerTracksSourceTracks, } from "frontend/src/domain/player-track-queue";
import { getPlaylistDetail } from "frontend/src/api/playlists";
import { getTimetablePlaylistForToday } from "frontend/src/api/timetables";
import { state } from 'frontend/src/shared/state';
export var $trackSourceLoadingMap = createStore({
    playlist: {},
    timetable: {},
});
export var createLoadTracksForTrackSourceModel = function () {
    var loadPlayerTracksSourceAttempted = createEvent();
    var tracksLoadedAndSet = createEvent();
    var playerTrackSourceToLoadFound = sample({
        clock: loadPlayerTracksSourceAttempted,
        source: $playerTrackQueue,
        fn: function (trackQueue, trackSourceId) {
            return trackQueue === null || trackQueue === void 0 ? void 0 : trackQueue.find(function (trackSource) { return trackSource.trackSourceId === trackSourceId; });
        },
    });
    var loadTracksForTrackSourceFx = createEffect(function (trackSource) {
        if (trackSource.type === "playlist") {
            state.currentTimetableId = -1;
            state.currentTimetableTitle = "";
            return getPlaylistDetail(trackSource.attributes.id).then(function (response) { return response.tracks; });
        }
        state.currentTimetableId = trackSource.attributes.id;
        state.currentTimetableTitle = trackSource.attributes.title;
        return getTimetablePlaylistForToday(trackSource.attributes.id);
    });
    guard({
        source: sample({
            clock: loadTracksForTrackSourceFx.done,
            source: $playerTrackQueue,
            fn: function (trackQueue, _a) {
                var params = _a.params, result = _a.result;
                var isThisTrackQueueStillPresent = !!(trackQueue === null || trackQueue === void 0 ? void 0 : trackQueue.find(function (trackSource) { return trackSource.trackSourceId === params.trackSourceId; }));
                return {
                    isThisTrackQueueStillPresent: isThisTrackQueueStillPresent,
                    trackSourceId: params.trackSourceId,
                    tracks: result,
                };
            },
        }),
        filter: function (_a) {
            var isThisTrackQueueStillPresent = _a.isThisTrackQueueStillPresent;
            return isThisTrackQueueStillPresent;
        },
        target: [
            // @ts-ignore
            setPlayerTracksSourceTracks.prepend(function (_a) {
                var tracks = _a.tracks, trackSourceId = _a.trackSourceId, isThisTrackQueueStillPresent = _a.isThisTrackQueueStillPresent;
                return ({
                    tracks: tracks,
                    trackSourceId: trackSourceId,
                });
            }),
            // @ts-ignore
            tracksLoadedAndSet.prepend(function (_a) {
                var tracks = _a.tracks, trackSourceId = _a.trackSourceId;
                return ({
                    tracks: tracks,
                    trackSourceId: trackSourceId,
                });
            }),
        ],
    });
    guard({
        source: playerTrackSourceToLoadFound,
        filter: function (trackSource) { return !!trackSource; },
        // @ts-ignore
        target: loadTracksForTrackSourceFx,
    });
    sample({
        clock: loadTracksForTrackSourceFx,
        source: $trackSourceLoadingMap,
        fn: function (map, trackSource) {
            var _a, _b;
            if (trackSource.type === "playlist") {
                return __assign(__assign({}, map), { playlist: (_a = {}, _a[trackSource.attributes.id] = true, _a) });
            }
            else if (trackSource.type === "today_timetable") {
                return __assign(__assign({}, map), { timetable: (_b = {}, _b[trackSource.attributes.id] = true, _b) });
            }
            return __assign({}, map);
        },
        target: $trackSourceLoadingMap,
    });
    sample({
        clock: loadTracksForTrackSourceFx.finally,
        source: $trackSourceLoadingMap,
        fn: function (map, _a) {
            var trackSource = _a.params;
            var copy = __assign({}, map);
            if (trackSource.type === "playlist") {
                delete copy.playlist[trackSource.attributes.id];
            }
            else if (trackSource.type === "today_timetable") {
                delete copy.timetable[trackSource.attributes.id];
            }
            return copy;
        },
        target: $trackSourceLoadingMap,
    });
    return {
        loadPlayerTracksSourceAttempted: loadPlayerTracksSourceAttempted,
        loadTracksForTrackSourceFx: loadTracksForTrackSourceFx,
        tracksLoadedAndSet: tracksLoadedAndSet,
    };
};
export var createLoadTracksForCurrentTrackSourceModel = function () {
    var _a = createLoadTracksForTrackSourceModel(), loadPlayerTracksSourceAttempted = _a.loadPlayerTracksSourceAttempted, tracksLoadedAndSet = _a.tracksLoadedAndSet;
    var loadPlayerCurrentTracksSourceAttempted = createEvent();
    guard({
        source: sample({
            clock: loadPlayerCurrentTracksSourceAttempted,
            source: $playerCurrentTrackSource,
            fn: function (trackSource) { return trackSource === null || trackSource === void 0 ? void 0 : trackSource.trackSourceId; },
        }),
        filter: function (trackSourceId) { return !!trackSourceId; },
        // @ts-ignore
        target: loadPlayerTracksSourceAttempted,
    });
    return { loadPlayerCurrentTracksSourceAttempted: loadPlayerCurrentTracksSourceAttempted, tracksLoadedAndSet: tracksLoadedAndSet };
};
